import FilterForm from 'components/forms/FilterForm';
import { Form, FormProps, Input, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export interface INoticeBoardFilterForm {
  title: string;
  kind: string;
  priority: number;
}

interface UsersFilterFormProps {
  searchFormProps: FormProps<INoticeBoardFilterForm>;
}

export const NoticeBoardListFilter = ({
  searchFormProps
}: UsersFilterFormProps) => {
  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="title">
        <Input placeholder="Título" suffix={<SearchOutlined />} />
      </Form.Item>

      <Form.Item name="kind">
        <Select placeholder="Destino" allowClear>
          <Select.Option value="course">Curso avulso</Select.Option>
          <Select.Option value="graduate_course">Curso regulado</Select.Option>
          <Select.Option value="classroom">Turma</Select.Option>
          <Select.Option value="general">Instituição</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item name="priority">
        <Select placeholder="Prioridade" allowClear>
          <Select.Option value="regular">Normal</Select.Option>
          <Select.Option value="high">Alta</Select.Option>
        </Select>
      </Form.Item>
    </FilterForm>
  );
};
